import React, { useEffect, useMemo, useState } from "react";
import { getPronounciation } from "../../../Pronounciation/getPronounciation";

const dummyText =
  "Christmas in 1979 was Soviet Union territory occupied by foreign forces invaded successfully";

const PronunciationAnalysis = ({ text}) => {
  const [items, setItems] = useState([]);      // final list for UI
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setError("");
        setLoading(true);

        // ✅ await the async function
        const res = await getPronounciation(text);

        if (!cancelled) setItems(res || []);
      } catch (e) {
        if (!cancelled) setError(e?.message || "Failed to fetch pronunciation");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [text]);

  // Optional: filter / slice for UI only (you said UI will handle it)
  const filteredResults = useMemo(() => {
    return items; // or items.filter(x => x.score > 0) etc
  }, [items]);

  const playNativePronunciation = (word) => {
    const u = new SpeechSynthesisUtterance(word);
    u.rate = 0.8;
    window.speechSynthesis.cancel(); // stops overlapping speech
    window.speechSynthesis.speak(u);
  };

  return (
    <div className="w-full max-w-4xl mx-auto mt-4">
      <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-sm">
        <h3 className="font-semibold text-lg mb-3">Pronunciation Practice</h3>

        {loading && (
          <div className="text-sm text-gray-500 mb-2">Loading pronunciation…</div>
        )}

        {error && (
          <div className="text-sm text-red-600 mb-2">{error}</div>
        )}

        {!loading && !error && filteredResults.length === 0 && (
          <div className="text-sm text-gray-500 mb-2">No words found.</div>
        )}

        <div className="flex gap-3 overflow-x-auto pb-2 pr-1">
          {filteredResults.map((item, idx) => (
            <button
              key={`${item.word}-${idx}`}
              onClick={() => playNativePronunciation(item.word)}
              className="
                min-w-[180px] max-w-[220px] flex-shrink-0
                text-left
                border border-gray-200
                rounded-lg
                p-3
                bg-white
                hover:bg-gray-50
                active:bg-gray-100
                hover:shadow-sm
                transition
              "
            >

              {/* respell (better than spelling letters) */}
              <div className="text-xs text-red-600 mb-1 tracking-widest">
                {item.respell || ""}
              </div>

              {/* Word */}
              <div className="font-bold text-base text-gray-900 mb-2">
                {item.word}
              </div>

                            {/* IPA */}
              <div className="text-sm text-gray-600 italic mb-1 tracking-wide">
                {item.ipa || "Pronunciation"}
              </div>

              {/* CTA */}
              <div className="flex items-center gap-1 text-xs font-medium text-gray-700">
                🔊 <span>Tap to hear pronunciation</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PronunciationAnalysis;
